<template>
  <div class="asidebar">
    <div class="search-wrap">
        <p class="asidebartitle">选择使用场景</p>
        <el-input placeholder="搜索模板" v-model="params.keyword" @change="getIndexData">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
    </div>
    <div class="pager-wrap">
        <ul>
            <li :class="params.cid==0?'active':''" @click="categoryClick(0)">全部</li>
            <!-- <li :class="itemtypeIndex==-2?'active':''">热门应用</li> -->
            <li :class="params.cid==item.id?'active':''" @click="categoryClick(item.id)" v-for="(item,index) in itemtype" :key="index">{{item.title}}</li>
        </ul>
    </div>
    <el-scrollbar>
        <ul>
            <li v-for="(item,index) in list" :key="index" :class="pageId==item.id?'on':''" @click="jumppage(item.type,item.id)">
                <img class="tip" :src="tip" alt="" v-show="item.type == 1">
                <div class="avatar"><img :src="item.image" alt=""></div>
                <div class="msg">
                    <p>{{item.title}}</p>
                    <p>{{item.sub_title}}</p>
                </div>
            </li>
        </ul>
    </el-scrollbar>
  </div>
</template>

<script>
import {getIndexData } from '@/api/index'
export default {
    data(){
        return {
			params:{
				cid:0,
				keyword:'',
			},
            itemtypeIndex:-1,
            itemtype:[],
            listIndex:2,
			pageId: 0,
			currentType:2,
			tip:require("../../assets/copywriting/tag-video-nav-6dd7b2ef.png"),
            list:[]
        }
    },
    mounted () {
        let path = this.$route.path
        switch (path){
            case "/microvideo":
                this.listIndex = -1
            break;
            case "/face":
                this.listIndex = -3
            break;
            case "/customized":
                this.listIndex = -2
            break;
            default:
                this.listIndex = this.$route.params.id
            break
        }
    },
	created() {
		this.pageId = this.$route.params.id;
		if(this.$route.path == '/microvideo'){
			this.pageId = 1;
			this.currentType = 1;
		}else if(this.$route.path == '/customized') {
			this.pageId = 2;
			this.currentType = 1;
		}else if(this.$route.path == '/face') {
			this.pageId = 3;
			this.currentType = 1;
		}else if (this.$route.path == '/clone') {
			this.pageId = 4;
			this.currentType = 1;
		  }
		this.getIndexData();
	},
    methods:{
		categoryClick(cid) {
			this.params.cid = cid;
			this.getIndexData();
		},
		getIndexData() {
			var that = this;
			getIndexData(this.params).then(response => {
				// console.log(response)
				that.itemtype = response.data.category;
				that.list = response.data.template;
				that.list.forEach((item) => {
					if(item.id == that.pageId) {
						that.currentType = item.type;
					}
				})
			});
		},
        jumppage(type,id){
           if (type == 2) {
			   if(this.currentType == 2) {
					// this.pageId = id;
					this.$router.replace({ path: "/copywriting/" + id });
					window.location.reload();
			   }else {
				   this.$router.push({ path: "/copywriting/" + id });
			   }
           } else {
			  if(id == 1) {
				  this.$router.push({ path: '/microvideo'});
			  }else if(id == 2) {
				  this.$router.push({ path: '/customized'});
			  }else if(id == 3) {
				  this.$message({
					  message:'暂未开放'
				  })
				  console.log(111)
				  // this.$router.push({ path: '/face'});
			  }else if(id == 4) {
				  this.$router.push({ path: 'clone'});
			  }
           }
        },
    },

}
</script>

<style lang="less">
    .asidebar{
        width: 340px;
        height: calc(100vh - 60px);
        background: #ffffff;
        display: flex;
        flex-direction: column;
        padding: 0 16px;
        overflow: hidden;
        .search-wrap{
            .asidebartitle{
                padding: 16px 0;
            }
        }
        .pager-wrap{
            ul{
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                margin: 16px 0;
                li{
                    padding: 4px 10px;
                    font-size: 12px;
                    background: #f4f5f7;
                    text-align: center;
                    padding: 5px 12px;
                    border: 1px solid #f4f5f7;
                    border-radius: 6px;
                    background: #f4f5f7;
                    flex-shrink: 0;
                    cursor: pointer;
                    position: relative;
                }
                .active{
                    border-color: #2d8af5;
                    background: #2d8af5;
                    color: #fff;
                }
            }
        }
        .el-scrollbar{
            flex:1 0 10%;
        }
        .el-scrollbar__wrap{
            height: 100%;
            overflow-x: hidden;
            ul{
                li{
                    display: flex;
                    align-items: center;
                    border: 1px solid #e6e9ed;
                    height: 76px;
                    border-radius: 8px;
                    margin-bottom: 12px;
                    cursor: pointer;
                    position: relative;
                    .tip{
                        position: absolute;
                        top: 0;
                        right: 0;
                        width: 46px;
                    }
                    .avatar{
                        width: 48px;
                        height: 48px;
                        border-radius: 8px;
                        box-shadow: 0 0 4px rgba(0,19,56,.1);
                        margin: 0 16px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        box-sizing: border-box;
                        img{
                            width: 24px;
                            height: 24px;
                            object-fit: fill;
                        }
                    }
                    .msg{
                        margin-right: 16px;
                        p:nth-child(1){
                            margin-bottom: 8px;
                            font-weight: 600;
                        }
                        p:nth-child(2){
                            color: #999;
                            font-size: 12px;
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                        }
                    }
                }
                .on{
                    border-color: #2d8af5;
                }
            }
        }
    }
</style>